/**优惠券选择**/
<template>
  <div class="couponSelect" :class="state?'couponSelectShow':''">
    <span class="couponSelectCont" @click="stateFn(showState,'show')">
      <p v-if="counponDataFn.length>0 && showStateType===''">选择优惠券</p>
      <p v-else-if="counponDataFn.length>0 && showStateType==='di'">优惠券已抵扣<span class="red">{{showState}}</span>元</p>
      <p v-else-if="counponDataFn.length>0 && showStateType==='zhe'">优惠券已折扣<span
        class="red">{{showState/10}}</span>折</p>
      <p v-else>暂无优惠券</p>
    </span>
    <div class="couponSelectList">
      <div class="Title">
        <h2>选择优惠券</h2>
      </div>
      <div class="Content">
        <div v-if="counponDataFn.length<=0">
          <p>暂无优惠券</p>
          <router-link :to="{path:'/coupon/nused',query: {addState: true}}">点击前往添加</router-link>
        </div>
        <div style="height: 100%" v-else-if="counponDataFn.length>0">
          <div><span class="nonuseBut" @click="stateFn('','nonuse')">不使用优惠券</span></div>
          <ul>
            <li class="clear" v-for="(item,index) in counponDataFn" @click="stateFn(item,'action',index)"
                :class="acNum===index?'acLi':''">
              <div v-if="item.deductible" class="name">
                <span class="badge deduction">抵</span><span class="text">{{item.title}}</span>
              </div>
              <div v-if="item.discount" class="name">
                <span class="badge discount">折</span><span class="text">{{item.title}}</span>
              </div>
              <div class="time" v-if="item.end_time">
                {{item.end_time.split(' ')[0]}}
                <span>到期</span>
              </div>
              <div class="time" v-else>
                永久
                <span>使用</span>
              </div>
              <div v-if="item.deductible" class="val"><span class="red">{{item.deductible}}</span>元</div>
              <div v-if="item.discount" class="val"><span class="red">{{item.discount/10}}</span>折
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="closeBut" @click="stateFn">
        <span>X</span>
      </div>
    </div>
    <div class="module" @click="stateFn" v-if="state"></div>
    <!--<xk-upload-mod :state="loadStateFn"></xk-upload-mod>-->
  </div>
</template>

<script>
  import Toucth from '../../../../assets/js/method'
  import XkUploadMod from '../../uploadMod/src/uploadMod'
  import {mapGetters} from 'vuex'
  import JSONBig from 'json-bigint-xk'

  export default {
    components: {XkUploadMod},
    name: 'xk-couponSelect',
    props: ['data', 'type'],
    data () {
      return {
        state: false,
        staticState: false,
        showState: '',
        acNum: 0,
        // showStateType: this.$props.data && this.$props.data.length > 0 ? (this.$props.data[0].deductible ? 'di' : 'zhe') : ''
        showStateType: '',
        enterprise_id: '' // 企业客户ID
      }
    },
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      }),
      // loadStateFn: function () {
      //   return !this.$props.data
      // },
      counponDataFn: function () {
        var counponData = this.data
        var obj = []
        if (counponData && counponData.length > 0) {
          counponData.forEach((row) => {
            // 优惠券开始生效时间在当前时间之后，不显示
            let time = Date.parse(new Date()) / 1000
            if (row.begin_time > time) {
              return false
            }
            // var endTime = row.end_time
            if (row.state === 1) { // state 1 未使用
              // if (endTime) {
              //   if (new Date().valueOf() < endTime * 1000) {
              //     obj.push(row)
              //   }
              // } else {
              //   row.end = null
              //   obj.push(row)
              // }
              if (row.end_time) {
                if (row.end_time * 1000 > new Date().getTime()) { // 如果优惠券还没有过期
                  row.end_time = Toucth.TimestampDate(row.end_time * 1000)
                  obj.push(row)
                }
              } else {
                row.end_time = '永久有效'
                obj.push(row)
              }
              if (!row.title || row.title === '') {
                if (row.main_service_type && row.main_service_type === 'daijia') {
                  row['title'] = '代驾券'
                }
              }
            }
          })
        }
        return obj
      }
    },
    methods: {
      timeFn (val) {
        return new Date(parseInt(val) * 1000).toLocaleString().split(' ')[0]
        // return new Date(parseInt(val) * 1000).toLocaleString().replace(/年|月/g, '-').replace(/日/g, '')
      },
      stateFn: function (obj, type, index) {
        let that = this
        this.$store.dispatch('checkLogin', (state) => {
          if (state && that.loginData && that.loginData.passenger) {
            this.state = !this.state
          } else {
            that.couponStatic = false
            that.$store.dispatch('loginAction', {state: false})
          }
        })
        this.$emit('click', {type: type, obj: obj})
        switch (type) {
          case 'nonuse':
            that.acNum = index
            this.showState = ''
            this.showStateType = ''
            break
          case 'action':
            that.acNum = index
            this.showState = obj.deductible ? obj.deductible : obj.discount
            this.showStateType = obj.deductible ? 'di' : 'zhe'
            break
        }
      },
      defaultFn: function (val) {
        this.showState = val.deductible ? this.$props.data[0].deductible : this.$props.data[0].discount
        this.showStateType = this.$props.data[0].deductible ? 'di' : 'zhe'
        this.$emit('click', {type: 'action', obj: val})
      }
    },
    created () {
      let passengerkey = window.configure.passengerKey
      let passenger = this.$Cookie.get(passengerkey) ? JSONBig.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerkey))) : null
      if (passenger && passenger.passenger) {
        this.enterprise_id = passenger.passenger.enterprise_id
      }
    },
    mounted: function () {
      let that = this
      setTimeout(() => {
        if (that.$props.data && that.$props.data.length > 0 && !this.enterprise_id) {
          that.defaultFn(that.$props.data[0])
        }
      }, 200)
    }
  }
</script>

<style rel="stylesheet/less" lang="less">
  .couponSelect {
    position: relative;
    width: 100%;
    height: 100%;
    .couponSelectCont {
      width: 100%;
      height: 100%;
      position: relative;
      font-size: 0.8333rem;
      .red {
        color: red;
        font-size: 1.25rem;
        margin: 0 0.3rem;
      }
    }
    .couponSelectList {
      box-sizing: border-box;
      position: fixed;
      min-width: 85%;
      height: 50%;
      left: 50%;
      top: 50%;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      font-size: 1rem;
      color: #333;
      line-height: 3.5rem;
      transition: 0.3s all;
      transform-origin: 0 0;
      transform: translate(-50%, -50%) scale(1, 0.6);
      opacity: 0;
      z-index: -10;
      text-align: center;
      .Title {
        line-height: 3.5rem;
        border-radius: 0.333rem 0.333rem 0 0;
        overflow: hidden;
        color: #333;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        background: #fff;
        position: relative;
        z-index: 50;
        h2 {
          color: #333333;
        }
      }
      .Content {
        height: calc(~'100% - 3.5rem');
        border-radius: 0 0 0.333rem 0.333rem;
        overflow-y: auto;
        background: #eee;
      }
      ul {
        box-sizing: border-box;
        width: 100%;
        padding: 0 0.5rem;
        padding-bottom: 1rem;
      }
      li {
        border-top: 1px solid #eee;
        padding: 0 0.5rem;
        line-height: 4.5rem;
        background: #fff;
        border-radius: 0.333rem;
        margin: 0.5rem 0;
      }
      li:nth-last-child(1) {
        border-bottom: 1px solid #eee;
      }
      .nonuseBut {
        line-height: 4rem;
      }
      .acLi {
        background: rgba(0, 0, 0, .05);
      }
      .name {
        float: left;
        span {
          vertical-align: middle;
        }
        .badge {
          display: inline-block;
          width: 1.4rem;
          height: 1.4rem;
          text-align: center;
          line-height: 1.6rem;
          border-radius: 0.333rem;
          overflow: hidden;
          font-size: 0.8333rem;
          color: #fff;
          margin-right: 0.3rem;
        }
        .deduction {
          background-color: #f02e1b;
        }
        .discount {
          background-color: #f0a638;
        }
        .text {
          display: inline-block;
          width: 5rem;
          max-width: 5rem;
          line-height: 4.5rem;
          height: 4.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .time {
        float: left;
        margin-left: 1rem;
        color: #999;
        width: 8.5rem;
        text-align: right;
        span {
          margin-left: 0.5rem;
        }
      }
      .val {
        float: right;
        font-size: 0.833rem;
        color: #898989;
        width: auto !important;
        min-width: inherit !important;
        margin-top: -0.2rem;
      }
      .red {
        color: red;
        font-size: 1.25rem;
        margin: 0 !important;
      }
      .closeBut {
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        text-align: center;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translate(-50%, 10%);
        z-index: 30;
        box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          color: #666;
          transform: translate(-44%, -45%);
        }
      }
    }
    .module {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: -10;
    }
  }

  .couponSelectShow {
    z-index: 100;
    .couponSelectCont {
      z-index: 10;
    }
    .couponSelectList {
      transform: translate(-50%, -50%) scale(1, 1);
      opacity: 1;
      z-index: 20;
    }
    .module {
      z-index: 10;
    }
  }
</style>


// WEBPACK FOOTER //
// couponSelect.vue?fc4dd1c2